var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftMost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 472,
    height: 442,
    viewBox: "0 0 472 442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5059 385.71C64.4445 365.904 44.1984 341.292 30.114 313.536C16.0301 285.782 8.42984 255.519 7.81476 224.78C7.19969 194.041 13.5837 163.523 26.5461 135.273C39.5089 107.022 58.7541 81.6864 83.0029 60.9758",
    stroke: "#A2F8C5",
    strokeWidth: 7,
    strokeDasharray: "1.96 20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2659 387.279C62.9832 367.299 42.5492 342.462 28.3305 314.441C14.112 286.421 6.43633 255.864 5.81517 224.82C5.194 193.777 11.6416 162.96 24.7283 134.439C37.8153 105.918 57.2401 80.3493 81.704 59.4549",
    stroke: "#A2F8C5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftMost);
export default __webpack_public_path__ + "static/media/left_most.ae19350660efa506476a508656831121.svg";
export { ForwardRef as ReactComponent };